import { NgModule } from "@angular/core";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { MessagesModule } from "app/layout/common/messages/messages.module";
import { NotificationsModule } from "app/layout/common/notifications/notifications.module";
import { SearchModule } from "app/layout/common/search/search.module";
import { SharedModule } from "app/shared/shared.module";
import { ClassicLayoutComponent } from "./classic.component";
import { FuseFullscreenComponent } from "@fuse/components/fullscreen";
import { FuseLoadingBarComponent } from "@fuse/components/loading-bar";
import { FuseHorizontalNavigationComponent, FuseVerticalNavigationComponent } from "@fuse/components/navigation";

@NgModule({
  declarations: [ClassicLayoutComponent],
  exports: [ClassicLayoutComponent],
  imports: [
    RouterModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MessagesModule,
    NotificationsModule,
    SearchModule,
    SharedModule,
    FuseFullscreenComponent,
    FuseLoadingBarComponent,
    FuseVerticalNavigationComponent,
    FuseHorizontalNavigationComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class ClassicLayoutModule {}
